export function priceWithDiscount(price: number, discount: number): number
export function priceWithDiscount(price: number | undefined, discount: number): number | undefined
export function priceWithDiscount(price: number | undefined, discount: number) {
  if (price === undefined) {
    return undefined
  }
  return discount > 0 ? (1 - discount / 100) * price : price
}
